var map = {
	"./community-category/index.sync.tsx": 868,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 869,
	"./header-navigation/index.sync.tsx": 897,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 914,
	"./knowledge-base/index.sync.tsx": 917,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 929,
	"./widget-featured-topics/index.sync.tsx": 390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1361;